import {
    Dispatch,
    SetStateAction,
    useContext,
    useEffect,
    useState,
} from 'react'
import { SpinnerCircular, Notification } from '@weirgroup/weir-dls'
import { DisplayMap } from '../../components/map/map'
import { Filter } from './components/filter'
import { PopupModal } from '../../components/Modal/modal'
import settingsApi from '../../api/settings.api'
import { AppConfigContext } from '../../contexts/app-config.context'
import { TableView } from './components/table-view'
import { getFilters } from '../../helpers/getFilters'
import { onFilterAssets } from '../../utils/on-filter-assets'

import { FetchedUserSettingType, RolesType } from '../../types/user.type'
import { AssetType, BucketDataType } from '../../types/bucketTypes'
import { FilterType, SelectedFilterType } from '../../types/filter.type'

import { useTranslation } from 'react-i18next'
import { groupReplacementParts } from '../../utils/replacement-parts.util'
import { getClientTimeZone } from '../../helpers/timezone.helper'
import {
    GUEST_POPUP,
    ROLES,
    StorageService,
} from '../../services/storage_service'
import { Roles } from '../../constants/roles.constants'
import { GuestPopup } from './components/guest-popup'
import { ToastDataType } from '../../types/toast.type'
import { fetchBucketList } from '../../utils/getTagData.utils'
import { useDarkMode } from '../../hooks/use-darkmode'
interface Props {
    selectedAsset: any
    setSelectedAsset: Dispatch<SetStateAction<any>>
}
export const MapPage = (props: Props) => {
    const { t } = useTranslation()
    const { selectedAsset, setSelectedAsset } = props
    const appConfigStore = useContext(AppConfigContext)
    const [assetData, setAssetData] = useState<AssetType[]>([])
    const [filteredAssetData, setFilteredAssetData] = useState<any>([])
    const [filteredBucketList, setFilteredBucketList] = useState<any>([])
    const [searchQuery, setSearchQuery] = useState<string>('')
    const [filters, setFilters] = useState<FilterType[]>([])
    const [tagData, setTagData] = useState<any>()
    const [replacementParts, setReplacementParts] = useState<any>()
    const [isModalShown, setIsModalShown] = useState(false)
    const [isTableShown, setIsTableShown] = useState<boolean>(false)
    const [isFetching, setIsFetching] = useState<boolean>(false)
    const [isRefetching, setIsRefetching] = useState<boolean>(false)
    const [isGuest, setIsGuest] = useState<boolean>(false)
    const [isGuestPopupShown, setIsGuestPopupShown] = useState<boolean>()
    const [isFetchingGeofences, setIsFetchingGeofences] =
        useState<boolean>(false)
    const [showToast, setShowToast] = useState<boolean>(false)
    const [toastData, setToastData] = useState<any>()

    const roleData = StorageService.getItem(ROLES)
    const guestPopupStorageData: string | null =
        StorageService.getItem(GUEST_POPUP)

    const {darkMode} = useDarkMode()

    useEffect(() => {
        if (isGuest) {
            if (guestPopupStorageData) {
                let shown = guestPopupStorageData == 'true'
                setIsGuestPopupShown(shown)
            } else {
                StorageService.setItem(GUEST_POPUP, false)
            }
        }
    }, [guestPopupStorageData, isGuest])

    useEffect(() => {
        if (roleData) {
            const roles: RolesType = JSON.parse(roleData)
            setIsGuest(roles?.role == Roles.GUEST)
        }
    }, [roleData])
    const fetchBucketListFunc = async () => {
        // I created a fetchBucketListFunc function and incorporated the fetchBucketList global function within it
        setIsFetching(true)
        fetchBucketList()
            .then((data) => {
                setAssetData(data.fetchedAssets)
                setFilteredAssetData(data.fetchedAssets)
                if (data.fetchedAssets) {
                    const buckets = extractBucketList(data.fetchedAssets)
                    setFilteredBucketList(buckets)
                     // added
                    const updatedSelectedAsset = buckets.filter(
                        (bucket: BucketDataType) => {
                            return bucket.asset_id == selectedAsset.asset_id
                        }
                    )
                    setSelectedAsset(updatedSelectedAsset[0])
                    if (data.refetch) {
                        setIsRefetching(data.refetch)
                    }
                }
                setIsFetching(false)
            })
            .catch((error: any) => {
                setIsFetching(false)
            })
    }
    useEffect(() => {
        if (isRefetching) {
            const updatedSelectedAsset = filteredBucketList.filter(
                (bucket: BucketDataType) => {
                    return bucket.asset_id == selectedAsset.asset_id
                }
            )
            setSelectedAsset(updatedSelectedAsset[0])
            setIsRefetching(false)
        }
    }, [selectedAsset, isRefetching])
    useEffect(() => {fetchBucketListFunc().then((data)=>{})},[])
    const fetchUserSettings = async () => {
        const fetchedData = await settingsApi.getUserSettings()
        const userSettings: FetchedUserSettingType = fetchedData.data.data
        if (userSettings) {
            appConfigStore.setTimezone(
                userSettings.timezone ?? getClientTimeZone()
            )
            appConfigStore.setLanguage(userSettings.language)
            appConfigStore.setUnits(userSettings.units)
            appConfigStore.setAssetEmailNotification(
                userSettings.asset_email_notification
            )
            appConfigStore.setGeofenceEmailNotification(
                userSettings.geofence_email_notification
            )
            appConfigStore.setInAppNotification(userSettings.inapp_notification)
        }
    }

    const extractBucketList = (assetData: AssetType[]) => {
        let buckets: BucketDataType[] = []
        assetData.forEach((asset: AssetType) => {
            let esnTagId = asset.tag?.esn
            let bucket = asset.bucket
            bucket.tag_id = esnTagId
            let data = bucket
            buckets.push(data)
        })
        return buckets
    }

    const applyFilters = (filteredAssets: AssetType[]) => {
        if (!filters || filters.length === 0) {
            return filteredAssets;
        }
    
        const selectedFilters: SelectedFilterType[] = [];
        filters.map((filter) => {
            filter.type.map((item) => {
                if (item.checked) {
                    const selected = {
                        category: filter.category.toLocaleLowerCase(),
                        title: item.title,
                    };
                    selectedFilters.push(selected);
                }
            });
        });
        return onFilterAssets(selectedFilters, filteredAssets);
    };

    const filterAssets = () => {
        if (!filters) {
            return;
        }
    
        if (!assetData) {
            return;
        }
    
        let filteredAssets: any = [];
        if (searchQuery && filters.length === 0) {
            filteredAssets = assetData.filter((asset: AssetType) => {
                return asset.bucket.serial_number
                    .toLowerCase()
                    .trim()
                    .includes(searchQuery.toLowerCase().trim());
            });
        }
    
        if (filters.length > 0 && searchQuery.length === 0) {
            filteredAssets = applyFilters(assetData);
        }
    
        if (searchQuery && filters.length > 0) {
            filteredAssets = applyFilters(assetData);
            filteredAssets = filteredAssets.filter((asset: AssetType) => {
                return asset.bucket.serial_number
                    .toLowerCase()
                    .trim()
                    .includes(searchQuery.toLowerCase().trim());
            });
        }
        setFilteredAssetData(filteredAssets);
        setFilteredBucketList(extractBucketList(filteredAssets));
    };

    const getTagData = (selectedAsset: any) => {
        const data: any = assetData.filter((asset: AssetType) => {
            if (asset.asset_id == selectedAsset.asset_id) {
                return asset.tag
            }
        })
        return data.length > 0 ? data?.[0]?.tag : null
    }

    useEffect(() => {
        if (!isModalShown) {
            setSelectedAsset(null)
            setTagData(null)
        }
    }, [isModalShown])

    useEffect(() => {
        if (selectedAsset) {
            setReplacementParts(
                groupReplacementParts(selectedAsset.replacement_parts)
            )
            let tagInfo = getTagData(selectedAsset)
            setTagData(tagInfo)
        }
    }, [selectedAsset])

    useEffect(() => {
        setFilters(getFilters(assetData))
    }, [assetData])

    useEffect(() => {
        // I invoke the local variable fetchBucketListFunc here.
        ;(async () => {
            fetchBucketList()
                .then(() => {
                    setIsFetching(false)
                })
                .catch((error: any) => {
                    setIsFetching(false)
                })
            await fetchUserSettings()
        })()
    }, [])

    const triggerToastMessage = (success: boolean, result?: any) => {
        const toastData: ToastDataType = {
            message: success ? result.data : result.response.data.message,
            variant: success ? 'success' : 'critical',
        }
        setShowToast(true)
        setToastData(toastData)
    }

    useEffect(() => {
        if (showToast) {
            setTimeout(() => setShowToast(false), 5000)
        }
    }, [toastData])

    return (
        <>
            <div className={"map-page-container"} style={{backgroundColor:darkMode ? '#3B434C' : '#F6F7F8'}}>
                <div className='filter-container' >
                    <Filter
                        isTableShown={isTableShown}
                        setIsTableShown={setIsTableShown}
                        filterAssets={filterAssets}
                        setSearchQuery={setSearchQuery}
                        filters={filters}
                        setFilters={setFilters}
                    />
                </div>
                {isFetching ? (
                <div className='map-table-view-container'>
                        <div className="fetch-spinner">
                            <SpinnerCircular darkMode={darkMode} />
                            <p style={{color:darkMode ? "white" : "black"}}>{t('fetchingAssets').toString()}</p>
                        </div>
                    </div>
                ) : (
                    <div className='map-table-view-container'>
                    {isTableShown ? (
                            <TableView
                                bucketList={filteredBucketList}
                                isModalShown={isModalShown}
                                setIsModalShown={setIsModalShown}
                                setSelectedAsset={setSelectedAsset}
                                getTagData={getTagData}
                                setTagData={setTagData}
                                isFetchingGeofences={isFetchingGeofences}
                            />
                        ) : (
                            <DisplayMap
                                bucketList={filteredAssetData}
                                setIsModalShown={setIsModalShown}
                                isModalShown={isModalShown}
                                setSelectedAsset={setSelectedAsset}
                                getTagData={getTagData}
                                setTagData={setTagData}
                            />
                        )}
                    </div>

                )}
            </div>
            {isModalShown ? (
                <PopupModal
                    selectedAsset={selectedAsset}
                    setSelectedAsset={setSelectedAsset}
                    isModalShown={isModalShown}
                    setIsModalShown={setIsModalShown}
                    tagData={tagData}
                    fetchBucketList={fetchBucketListFunc} // I also invoke the fetchBucketListFunc for the popup modal.
                    replacementParts={replacementParts}
                    isGuest={isGuest}
                    isFetchingGeofences={isFetchingGeofences}
                    setIsFetchingGeofences={setIsFetchingGeofences}
                    triggerToastMessage={triggerToastMessage}
                />
            ) : (
                <></>
            )}
            {!isGuestPopupShown && isGuest ? (
                <GuestPopup isGuestPopupShown={isGuestPopupShown} />
            ) : (
                <></>
            )}
            {showToast ? (
                <div className="toast-container">
                    <Notification 
                        title={toastData.variant == "success" ? "Success" : "Fail"}
                        textContent={toastData.message}
                        variant={toastData.variant}
                        onClose={()=>{setShowToast(false)}}
                    />
                </div>
            ) : (
                <></>
            )}
        </>
    )
}

export default MapPage
